
document.addEventListener("DOMContentLoaded", function () {
    const navbar = document.querySelector(".navbar");
    const simpleDropdowns = document.querySelectorAll(".navbar-link.is-simple-dropdown-toggle");
    const menuButton = document.querySelector(".navbar-menu-button");
    let removeTimeout;

    // === Navbar dropdown behavior ===
    function updateNavbarState() {
        const isAnyOpen =
            [...simpleDropdowns].some(dropdown => dropdown.classList.contains("w--open")) ||
            menuButton.classList.contains("w--open");

        if (isAnyOpen) {
            clearTimeout(removeTimeout);
            navbar.classList.add("is-open");
        } else {
            removeTimeout = setTimeout(() => {
                navbar.classList.remove("is-open");
            }, 300);
        }
    }

    const dropdownObserver = new MutationObserver(updateNavbarState);
    simpleDropdowns.forEach(dropdown =>
        dropdownObserver.observe(dropdown, { attributes: true, attributeFilter: ["class"] })
    );
    dropdownObserver.observe(menuButton, { attributes: true, attributeFilter: ["class"] });

    simpleDropdowns.forEach(toggle => {
        toggle.addEventListener("click", () => {
            // Se mantiene la estructura si deseas agregar algo más en el futuro
        });
    });


    // === Dynamic color behavior ===
    let currentTextColor = null;
    let currentGradientColor = null;
    let rafPending = false;

    function getScrollThresholdFromCSS() {
        const temp = document.createElement('div');
        temp.style.position = 'absolute';
        temp.style.visibility = 'hidden';
        temp.style.pointerEvents = 'none';
        temp.style.height = 'calc(var(--_sizing---logo-sizing--scrolled) + (2 * var(--_sizing---spacing--xs)))';
        document.body.appendChild(temp);
        const pxValue = parseFloat(getComputedStyle(temp).height);
        document.body.removeChild(temp);
        return pxValue;
    }

    function isInViewport(el, threshold) {
        const rect = el.getBoundingClientRect();
        return rect.top <= threshold && rect.bottom >= threshold;
    }

    function getVisibleSlideColor(slider, threshold) {
        if (!isInViewport(slider, threshold)) return null;

        const visibleSlide = [...slider.querySelectorAll('.w-slide')]
            .find(s => getComputedStyle(s).visibility !== "hidden");

        if (visibleSlide && visibleSlide.hasAttribute("data-text-color") && visibleSlide.hasAttribute("data-gradient-color")) {
            return {
                textColor: visibleSlide.getAttribute("data-text-color"),
                gradientColor: visibleSlide.getAttribute("data-gradient-color"),
                sliderEl: slider
            };
        }

        return null;
    }

    function applyColors(textColor, gradientColor, sliderEl = null) {
        if (rafPending) return;
        rafPending = true;

        requestAnimationFrame(() => {
            rafPending = false;

            if (textColor === currentTextColor && gradientColor === currentGradientColor) return;

            currentTextColor = textColor;
            currentGradientColor = gradientColor;

            document.body.style.setProperty("--navbar-colors--text", textColor, "important");
            document.body.style.setProperty("--navbar-colors--gradient", gradientColor, "important");

            navbar.style.setProperty("--navbar-colors--text", textColor, "important");
            navbar.style.setProperty("--navbar-colors--gradient", gradientColor, "important");

            if (sliderEl) {
                sliderEl.style.setProperty("--navbar-colors--text", textColor, "important");
                sliderEl.style.setProperty("--navbar-colors--gradient", gradientColor, "important");
            }
        });
    }

    function updateNavbarColors() {
        const threshold = getScrollThresholdFromCSS();
        const allTargets = document.querySelectorAll("[data-text-color][data-gradient-color]");

        // 1. Slider visible tiene prioridad
        const sliders = document.querySelectorAll(".w-slider");
        for (const slider of sliders) {
            const result = getVisibleSlideColor(slider, threshold);
            if (result) {
                applyColors(result.textColor, result.gradientColor, result.sliderEl);
                return;
            }
        }

        // 2. Sección común
        for (const el of allTargets) {
            const rect = el.getBoundingClientRect();
            if (rect.top <= threshold && rect.bottom >= threshold) {
                const textColor = el.getAttribute("data-text-color");
                const gradientColor = el.getAttribute("data-gradient-color");
                applyColors(textColor, gradientColor);
                return;
            }
        }
    }

    window.addEventListener("scroll", () => {
        requestAnimationFrame(updateNavbarColors);
    });

    updateNavbarColors();

    // === Observadores para detectar cambios de slide
    const sliders = document.querySelectorAll(".w-slider");
    sliders.forEach(slider => {
        const slides = slider.querySelectorAll(".w-slide");
        slides.forEach(slide => {
            const observer = new MutationObserver(() => {
                updateNavbarColors();
            });

            observer.observe(slide, {
                attributes: true,
                attributeFilter: ["style", "class", "aria-hidden"]
            });
        });
    });
});
